import { render, staticRenderFns } from "./ProductIndexView.vue?vue&type=template&id=1b534a81"
import script from "./ProductIndexView.vue?vue&type=script&lang=js"
export * from "./ProductIndexView.vue?vue&type=script&lang=js"
import style0 from "./ProductIndexView.vue?vue&type=style&index=0&id=1b534a81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports